import { defineNuxtPlugin, useNuxtApp, navigateTo } from "#app";
import { useUserStore } from "~/stores/user";

export default defineNuxtPlugin((nuxtApp) => {
  const authStore = useUserStore();

  function can(permission: string, ownerId?: string) {    
    const hasPermission = authStore.permissions.includes(permission);

    // 1) resource owner can always act on their own resource
    if (ownerId && authStore.user?.id === ownerId && hasPermission) return true;

    // 2) otherwise check declared permissions
    return hasPermission;
  }

  // Inject globally
  //   nuxtApp.provide("can", can);
  //   nuxtApp.vueApp.config.globalProperties.$can = can;

  // Directive: v-can="[permission, ownerId?]"
  nuxtApp.vueApp.directive("can", {
    mounted(el, binding) {
      const [perm, owner] = Array.isArray(binding.value)
        ? binding.value
        : [binding.value];
      if (!can(perm, owner)) {
        el.parentNode?.removeChild(el);
      }
    },
  });

  nuxtApp.vueApp.directive("highlight", {
    mounted(el, binding) {
      el.style.backgroundColor = binding.value;
    },
  });

  return {
    provide: {
      can,
    },
  };
});

// Helper for script-setup
declare module "#app" {
  interface NuxtApp {
    $can(permission: string, ownerId?: string): boolean;
  }
}
